import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { ref } from 'vue'
import { addBiLoseWarning, updateBiLoseWarning } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { AddBiLoseWarningParams } from '@/typings/api/gucangSale'
import CusSelect from '@/components/CustomerCodeSelect/index.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { RISKLEVEL } from '../hooks/enum'
const __default__ = { name: 'editModal' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<AddBiLoseWarningParams>({})
const emit = __emit
const toggle = (row?: AddBiLoseWarningParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const selectData = (value: string) => {
  editForm.value.cosId = value
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId, riskLevel } = editForm.value
    const p = {
      arkCode,
      cosId,

      riskLevel
    }
    try {
      if (editForm.value.id) {
        await updateBiLoseWarning({ ...p, id: editForm.value.id })
      } else {
        await addBiLoseWarning(p)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: editForm.value.id ? '编辑' : '新增',
    width: "600px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef,
            autocomplete: "off"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "arkCode",
                label: "客户名称/代码",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(CusSelect, {
                    appId: "cos_fbu",
                    value: editForm.value.arkCode,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.arkCode) = $event)),
                    placeholder: "请选择",
                    onSelectData: selectData,
                    disabled: editForm.value.id
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "riskLevel",
                label: "风险程度",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: editForm.value.riskLevel,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.riskLevel) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, {
                        value: _unref(RISKLEVEL).LOW
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("低")
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_select_option, {
                        value: _unref(RISKLEVEL).MIDDLE
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("中")
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _createVNode(_component_a_select_option, {
                        value: _unref(RISKLEVEL).HIGH
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("高")
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})